import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLayersThree02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.723 1.085a1.5 1.5 0 0 1 .554 0 1.902 1.902 0 0 1 .528.2l9.642 4.82a1 1 0 0 1 0 1.79l-9.642 4.82-.026.014a1.902 1.902 0 0 1-.502.186 1.5 1.5 0 0 1-.554 0c-.216-.04-.41-.139-.502-.186l-.026-.013-9.642-4.822a1 1 0 0 1 0-1.788l9.642-4.821.026-.013c.093-.048.286-.147.502-.187Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m2.528 10.618-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.014c.093.047.286.146.502.186a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.186l.026-.014 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.886-.011.006a5.936 5.936 0 0 1-.29.138 3.489 3.489 0 0 1-2.043.233 3.489 3.489 0 0 1-.754-.233 5.936 5.936 0 0 1-.289-.138l-.011-.005-7.773-3.887Z"
    />
    <path
      fill="currentColor"
      d="m2.528 15.618-.975.487a1 1 0 0 0 0 1.79l9.642 4.82.026.014c.093.047.286.146.502.186a1.5 1.5 0 0 0 .554 0c.216-.04.41-.139.502-.186l.026-.014 9.642-4.82a1 1 0 0 0 0-1.79l-.975-.487-7.773 3.886-.011.006c-.05.025-.17.085-.29.137a3.489 3.489 0 0 1-2.043.234 3.489 3.489 0 0 1-.754-.234c-.12-.052-.24-.112-.289-.137l-.011-.006-7.773-3.886Z"
    />
  </svg>
);
SvgLayersThree02.displayName = 'LayersThree02';
export default SvgLayersThree02;
